<template>
  <div class="schedule_main" :class="{'cn':version == '1'}">
    <div class="cont_box scrollbar_style">
      <div class="sceneSelect">
        <div class="text p1"><span class="i">*</span>{{ $t('App.schedule.text10') }}</div>
        <div class="select_lm multiple" :class="sceneSelectShow?'select':''">
          <div class="val_box" @click="sceneSelectFun()">
            <div class="val" :title="sceneName">{{sceneName}}</div>
            <div class="icon_x"></div>
          </div>
          <div class="select_xl_lm_bg" v-if="sceneSelectShow" @click="sceneSelectFun()"></div>
          <div class="select_xl_lm" v-if="sceneSelectShow">
            <div class="icon"></div>
            <div class="ul scrollbar_style">
              <div class="li" v-for="(item,idx) in sceneNavList" :key="idx" @click="sceneItemClick(item)">
                <div class="text">{{ item.name }}</div>
                <div class="selectDrop" :class="sceneId.indexOf(item.id)!=-1 ?'select':''">
                  <div class="drop"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="text p1"><span class="i">*</span>{{ $t('App.schedule.text1') }}</div>

      <!-- <div class="select_lm" :class="sceneSelectShow ? 'select' : ''">
        <div class="val_box" @click="sceneSelectFun()">
          <div class="val" :title="sceneName">{{ sceneName }}</div>
          <div class="icon_x"></div>
        </div>
        <div class="select_xl_lm_bg" v-if="sceneSelectShow" @click="sceneSelectFun()"></div>
        <div class="select_xl_lm" v-if="sceneSelectShow">
          <div class="icon"></div>
          <div class="ul scrollbar_style">
            <div class="li" v-for="(item, index) in sceneNavList" :key="index" @click="sceneItemClick(item)">
              <div class="test">{{ item.name }}</div>
              <div class="selectDrop" :class="item.select==1?'select':''">
                <div class="drop"></div>
              </div>
            </div>
          </div>
        </div>
      </div> -->
      <div class="form_box">
        <!-- <el-select class="input1" v-model="scheduleForm.timeType" placeholder="" popper-class="select_popper">
          <el-option v-for="item in timeTypeOptions" :key="item.id" :label="item.name" :value="item.id">
          </el-option>
        </el-select> -->
        <div class="select_lm" :class="timeTypeSelectShow ? 'select' : ''">
          <div class="val_box" @click="timeTypeSelectFun">
            <div class="val" :title="timeTypeName">{{ timeTypeName }}</div>
            <div class="icon_x"></div>
          </div>
          <div class="select_xl_lm_bg" v-if="timeTypeSelectShow" @click="timeTypeSelectFun"></div>
          <div class="select_xl_lm" v-if="timeTypeSelectShow">
            <div class="icon"></div>
            <div class="ul scrollbar_style">
              <div class="li" v-for="(item, index) in timeTypeOptions" :key="index" @click="timeTypeItemClick(item)">
                <div class="test">{{ item.name }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="form_ul" v-if="scheduleForm.timeType == 0">
          
          <div class="flex_box">
            <div class="li margin_b">
              <div class="text p1"><span class="i">*</span>{{ $t('App.schedule.text6') }}</div>
              <el-date-picker class="picker" v-model="scheduleForm.startDate" type="date" 
                value-format="yyyy-MM-dd">
              </el-date-picker>
            </div>
            <div class="li">
              <div class="text p1">{{ $t('App.schedule.text7') }}</div>
              <el-date-picker class="picker" v-model="scheduleForm.endDate" type="date"
                value-format="yyyy-MM-dd">
              </el-date-picker>
            </div>
          </div>
          <div class="flex_box">
            <div class="li margin_b">
              <div class="text p1"><span class="i">*</span>{{ $t('App.schedule.text4') }}</div>
              <el-time-picker v-model="scheduleForm.startTime" class="picker"
                format="HH:mm" value-format="HH:mm">
              </el-time-picker>
            </div>
            <div class="li margin_b">
              <div class="text p1">{{ $t('App.schedule.text5') }}</div>
              <el-time-picker v-model="scheduleForm.endTime" class="picker"
              format="HH:mm" value-format="HH:mm">
              </el-time-picker>
            </div>
          </div>
        </div>
        <div class="form_ul" v-if="scheduleForm.timeType == 1">
          <div class="flex_box">
            <div class="li margin_b">
              <div class="text p1"><span class="i">*</span>{{ $t('App.schedule.label1') }}</div>
              <!-- <el-time-picker v-model="scheduleForm.timeStart" class="picker">
              </el-time-picker> -->
            </div>
            <div class="li margin_b">
              <div class="text p1"><span class="i">*</span>{{ $t('App.schedule.label3') }}</div>
              <div class="flex_box">
                <el-input-number class="input1 number" :controls="false" v-model="scheduleForm.sunriseOffsetTime"
                  label=""></el-input-number>
                <div class="select_lm" :class="timeUnitSelectShow[0] ? 'select' : ''">
                  <div class="val_box" @click="timeUnitSelectFun(0)">
                    <div class="val" :title="timeUnitName[0]">{{ timeUnitName[0] }}</div>
                    <div class="icon_x"></div>
                  </div>
                  <div class="select_xl_lm_bg" v-if="timeUnitSelectShow[0]" @click="timeUnitSelectFun(0)"></div>
                  <div class="select_xl_lm" v-if="timeUnitSelectShow[0]">
                    <div class="icon"></div>
                    <div class="ul scrollbar_style">
                      <div class="li" v-for="(item, index) in timeUnitOptions" :key="index"
                        @click="timeUnitItemClick(item, 0)">
                        <div class="test">{{ item.name }}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- <el-time-picker v-model="scheduleForm.endTime" class="picker">
              </el-time-picker> -->
            </div>
          </div>
          <div class="flex_box">
            <div class="li margin_b">
              <div class="text p1"><span class="i">*</span>{{ $t('App.schedule.label2') }}</div>
              <!-- <el-date-picker class="picker" v-model="scheduleForm.startDate" type="date">
              </el-date-picker> -->
            </div>
            <div class="li">
              <div class="text p1"><span class="i">*</span>{{ $t('App.schedule.label4') }}</div>
              <div class="flex_box">
                <el-input-number class="input1 number" :controls="false" v-model="scheduleForm.sunsetOffsetTime"
                  label=""></el-input-number>
                <div class="select_lm" :class="timeUnitSelectShow[1] ? 'select' : ''">
                  <div class="val_box" @click="timeUnitSelectFun(1)">
                    <div class="val" :title="timeUnitName[1]">{{ timeUnitName[1] }}</div>
                    <div class="icon_x"></div>
                  </div>
                  <div class="select_xl_lm_bg" v-if="timeUnitSelectShow[1]" @click="timeUnitSelectFun(1)"></div>
                  <div class="select_xl_lm" v-if="timeUnitSelectShow[1]">
                    <div class="icon"></div>
                    <div class="ul scrollbar_style">
                      <div class="li" v-for="(item, index) in timeUnitOptions" :key="index"
                        @click="timeUnitItemClick(item, 1)">
                        <div class="test">{{ item.name }}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- <el-date-picker class="picker" v-model="scheduleForm.endDate" type="date">
              </el-date-picker> -->
            </div>
          </div>
        </div>
      </div>
      <div class="text p1">{{ $t('App.schedule.text8') }}</div>
      <div class="flex_box">
        <div class="flex_li" :class="scheduleForm.days.indexOf('0') != -1 ? 'select' : ''" @click="weekSelect('0')">{{$t('App.schedule.day0')}}
        </div>
        <div class="flex_li" :class="scheduleForm.days.indexOf('1') != -1 ? 'select' : ''" @click="weekSelect('1')">{{$t('App.schedule.day1')}}
        </div>
        <div class="flex_li" :class="scheduleForm.days.indexOf('2') != -1 ? 'select' : ''" @click="weekSelect('2')">{{$t('App.schedule.day2')}}
        </div>
        <div class="flex_li" :class="scheduleForm.days.indexOf('3') != -1 ? 'select' : ''" @click="weekSelect('3')">{{$t('App.schedule.day3')}}
        </div>
        <div class="flex_li" :class="scheduleForm.days.indexOf('4') != -1 ? 'select' : ''" @click="weekSelect('4')">{{$t('App.schedule.day4')}}
        </div>
        <div class="flex_li" :class="scheduleForm.days.indexOf('5') != -1 ? 'select' : ''" @click="weekSelect('5')">{{$t('App.schedule.day5')}}
        </div>
        <div class="flex_li" :class="scheduleForm.days.indexOf('6') != -1 ? 'select' : ''" @click="weekSelect('6')">{{$t('App.schedule.day6')}}
        </div>
      </div>
      <!-- <div class="add_btn">
        <div class="icon"></div> -->
        <!-- <div class="text">{{ $t('App.schedule.text9') }}</div> -->
      <!-- </div> -->
      <div class="btn_box">
        <div class="btn1 text" @click="pageTypeFun">{{ $t('App.cancel') }}</div>
        <div class="btn2 text" v-loading="loading.scheduleAdd" @click="saveSceneFun('calendar')">{{ $t('App.ok') }}</div>
      </div>
    </div>

		<!-- 选择页面 -->
		<el-dialog :show-close="false" :visible.sync="selectVisible" :close-on-click-modal="false" :close-on-press-escape="false" width="36.51rem" class="selection" >
			<el-radio-group style="display: grid;" v-model="getUserSettingInfoDateValue_">
				<el-radio :disabled="getUserSettingInfoDate.sysStatus === 1" label="systemSetting">{{$t('App.status.text0')}}</el-radio>
				<el-radio :disabled="getUserSettingInfoDate.projectStatus === 1" label="projectSettings">{{$t('App.status.text1')}}</el-radio>
				<el-radio :disabled="getUserSettingInfoDate.gatewayStatus === 1" label="gatewayInput">{{$t('App.projectSettings.text5')}}</el-radio>
				<el-radio :disabled="getUserSettingInfoDate.deviceStatus === 1" label="controllerInput">{{$t('App.status.text2')}}</el-radio>
				<el-radio :disabled="getUserSettingInfoDate.groupStatus === 1" label="groupSetting">{{$t('App.status.text3')}}</el-radio>
				<el-radio :disabled="getUserSettingInfoDate.sceneStatus === 1" label="sceneSettingEdit">{{$t('App.status.text4')}}</el-radio>
				<el-radio :disabled="getUserSettingInfoDate.scheduleStatus === 1" label="schedule">{{$t('App.status.text5')}}</el-radio>
			</el-radio-group>
			<span  slot="footer" class="footer">
				<el-button @click="projectSelection()">Enter</el-button>
			</span>
		</el-dialog>

    <!-- 获取用户设置状态信息 -->
    <div class="project_completed" v-if="isShowprojectCompleted">
      <div class="bg"></div>
      <div class="form_box" >
        <div class="span">
          {{$t('App.text14')}}
        </div>
        <div class="btn_box0">
          <!-- <div class="btn1" @click="isShowLogout = false">{{$t('App.no')}}</div> -->
          <div class="btn2" @click="closeProjectCompleted('calendar')">{{$t('App.ok')}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
import { mapGetters } from 'vuex'
import allUrl from '../api/allUrl.js'
import base from '../api/base.js'
export default {
  name: 'schedule',
  data() {
    return {
      sceneNavList:[],
      sceneSelectShow:false,
      isShowprojectCompleted:false,
      sceneName: '',
      sceneId: '',

      timeTypeSelectShow: false,
      timeTypeName: '',
      timeTypeOptions: [],

      timeUnitSelectShow: [false, false],
      timeUnitName: ['', ''],
      timeUnitOptions: [],

      scheduleForm: {
        days: '',
        timeType: '0',
        startDate: '',
        startTime: '',
        endDate: '',
        endTime: '',
        sunriseOffsetTime: '',
        sunsetOffsetTime: '',
        sunriseTimeUnit: '',
        sunsetTimeUnit: '',
      },
      
			selectVisible: false,
			getUserSettingInfoDateValue_:'systemSetting',
			getUserSettingInfoDate :{
				sysStatus:'',
				projectStatus:'',
				gatewayStatus:'',
				deviceStatus:'',
				groupStatus:'',
				sceneStatus:'',
				scheduleStatus:'',
			},

      loading: {
        scheduleAdd: false,
      }
    }
  },
  computed: {
    ...mapGetters({
      token: 'token',
      client_key: 'client_key',
      username: 'username',
      version: 'version',

      projectId: 'projectId',

      timezoneId:'timezoneId',


      scheduleData: 'scheduleData',
      scheduleType: 'scheduleType',

      remRatio: 'remRatio',
      updateRemRatio: 'updateRemRatio',

      projectUpdate: 'projectUpdate',

      countryId: 'countryId',
      provinceId: 'provinceId',
      cityId: 'cityId',
      hotelId: 'hotelId',
      headerIdStr: 'headerIdStr',
      themeType: 'themeType',
    }),
    // sensorFormModelName(){
    //     let name = '';
    //     for(let d of this.modelNav){
    //         if(d.id == this.sensorForm.model){
    //             name = d.name
    //         }
    //     }
    //     return name
    // }
  },
  components: {
    // 'sideBar':sideBar
  },
  beforeDestroy() {
  },
  mounted() {
    console.log(this.timezoneId,'--656565--')
    this.getUserSettingInfo();
    this.timeTypeOptions = [
      { id: 0, name: this.$t('App.schedule.text2') },
      { id: 1, name: this.$t('App.schedule.text3') }
    ]
    this.timeUnitOptions = [
      { id: 0, name: this.$t('App.schedule.timeUnit0') },
      { id: 1, name: this.$t('App.schedule.timeUnit1') }
    ]
    console.log(this.projectId)
    if(this.projectId){
      this.sceneNavGet()
    }
    this.timeTypeName = this.timeTypeOptions[0].name;
    this.scheduleForm.timeType = this.timeTypeOptions[0].id;
    if(this.scheduleType == 'edit'){
      for(let key in this.scheduleForm){
        this.scheduleForm[key] = this.scheduleData[key]
        if(key == ['timeType']){
          this.timeTypeName = this.timeTypeOptions[this.scheduleData[key]].name;
        }
      }
      this.sceneId = this.scheduleData.sceneId;
      this.sceneName = this.scheduleData.sceneName;
    }
  },
  methods: {
    skinClassFun(){
      let obj = {};
      obj['cn'] = this.version == '1';
      // obj['ratio_1920_1080'] = this.ratio == '1';
      if(this.themeType == 1){
        obj['themeType_' + 1] = true;
      }
      // obj['themeType_' + 1] = true;
      return obj
    },
		confirmSelection() {
      this.getUserSettingInfo(data => {
        if (data.isTrue) {
          this.selectVisible = true;
        }
      });
		},
		projectSelection(){
			this.$emit('pageTypeFun', this.getUserSettingInfoDateValue_)
			this.selectVisible = false;
		},
    closeProjectCompleted() {
			this.isShowprojectCompleted = close;
			// this.$emit('calendar', val)
      this.$emit('pageTypeFun', 'calendar',{'scheduleList':[this.scheduleForm]})
		},
		//获取用户设置状态信息
		getUserSettingInfo(callback) {
			// this.selectVisible = true;
			base.ajax_post(
				allUrl.user.user_getUserSettingInfo,
				{
				username: this.username,
				version: this.version,
				token:this.token,
				},
				{},
				data => {
          this.getUserSettingInfoDate = data.data;
          data.isTrue = false;
          if(this.getUserSettingInfoDate.sysStatus == 0){
            this.getUserSettingInfoDateValue_ = 'systemSetting'
            data.isTrue = true
          } else if(this.getUserSettingInfoDate.projectStatus == 0){
            this.getUserSettingInfoDateValue_ = 'projectSettings'
            data.isTrue = true
          }else if(this.getUserSettingInfoDate.gatewayStatus == 0){
            this.getUserSettingInfoDateValue_ = 'gatewayInput'
            data.isTrue = true
          } else if(this.getUserSettingInfoDate.deviceStatus == 0){
            this.getUserSettingInfoDateValue_ = 'controllerInput'
            data.isTrue = true
          } else if(this.getUserSettingInfoDate.groupStatus == 0){
            this.getUserSettingInfoDateValue_ = 'groupSetting'
            data.isTrue = true
          } else if(this.getUserSettingInfoDate.sceneStatus == 0){
            this.getUserSettingInfoDateValue_ = 'sceneSettingEdit'
            data.isTrue = true
          }else if(this.getUserSettingInfoDate.scheduleStatus == 0){
            this.getUserSettingInfoDateValue_ = 'schedule'
            data.isTrue = true
          }
          if(callback){
            callback(data)
          }
				},
				this
			)
		},
    pageTypeFun() {
      this.$emit('pageTypeFun', 'calendar',{'scheduleList':[this.scheduleForm]})
    },
    saveSceneFun() {
			if (!this.timezoneId) {
				this.scheduleAdd();
				console.log('--111')
			} else {
				this.scheduleUpdate();
				console.log('--5522')
			}
		},
    scheduleAdd() {
      // if (this.projectPageId) {
      //   this.projectUpdate()
      //   return
      // }
      if (this.loading.scheduleAdd) {
        return
      }
      if(!this.sceneId) {
        this.$message({
            showClose: true,
            message: this.$t("App.message.text42"),
            type: 'error'
          });
        return
      }
      let scheduleForm = JSON.parse(JSON.stringify(this.scheduleForm));
      if (scheduleForm.timeType == 0) {
        delete scheduleForm.sunriseOffsetTime;
        delete scheduleForm.sunriseTimeUnit;
        delete scheduleForm.sunsetOffsetTime;
        delete scheduleForm.sunsetTimeUnit;
      }
      if (scheduleForm.timeType == 1) {
        delete scheduleForm.startDate;
        delete scheduleForm.startTime;
        delete scheduleForm.endDate;
        delete scheduleForm.endTime;
      }
      scheduleForm.sceneIdList = this.sceneId.split(',')
      this.loading.scheduleAdd = true;
      base.ajax_post(
        allUrl.schedule.schedule_add,
        {
          username: this.username,
          version: this.version,
          token: this.token,
          projectId: this.projectId,
          ...scheduleForm
        },
        {},
        data => {
          this.$message({
            showClose: true,
            message: data.msg,
            type: 'success'
          });
          this.loading.scheduleAdd = false;
          // console.log(this.getUserSettingInfoDate.scheduleStatus,'--1011---')
          if(this.getUserSettingInfoDate.scheduleStatus == 0){
            this.confirmSelection()
          } else {
            this.$emit('pageTypeFun', 'calendar',{'scheduleList':[this.scheduleForm]})
          }
          this.$store.commit('projectUpdateFun', {
            projectUpdate: this.projectUpdate+1,
          })

        },
        this, () => {
          this.loading.scheduleAdd = false;
        }
      )
    },
    scheduleUpdate() {
      if (this.loading.scheduleAdd) {
        return
      }
      this.loading.scheduleAdd = true;
      base.ajax_post(
        allUrl.schedule.schedule_update,
        {
          username: this.username,
          version: this.version,
          token: this.token,

          id: this.timezoneId,
          timeType: this.scheduleForm.timeType,
          startDate: this.scheduleForm.startDate,
          startTime: this.scheduleForm.startTime,
          endDate: this.scheduleForm.endDate,
          endTime: this.scheduleForm.endTime,
          days: this.scheduleForm.days,
          sunriseOffsetTime: this.scheduleForm.sunriseOffsetTime,
          sunriseTimeUnit: this.scheduleForm.sunriseTimeUnit,
          sunsetOffsetTime: this.scheduleForm.sunsetOffsetTime,
          sunsetTimeUnit: this.scheduleForm.sunsetTimeUnit,
          sceneIdList: this.sceneId.split(',')
        },
        {},
        data => {
          this.$message({
            showClose: true,
            message: data.msg,
            type: 'success'
          });
          this.loading.scheduleAdd = false;
          this.$emit('pageTypeFun', 'calendar',{'scheduleList':[this.scheduleForm]})
          // this.$emit('pageTypeFun', 'calendar')
        },
        this, () => {
          this.loading.scheduleAdd = false;
        }
      )
    },
    weekSelect(val) {
      let arr = [];
      if (this.scheduleForm.days.length > 0) {
        arr = this.scheduleForm.days.split(',');
      }
      let isTrue = false;
      let index = 0;
      console.log(arr)
      for (let key in arr) {
        if (arr[key] === val) {
          isTrue = true;
          index = key
        }
      }
      console.log(index, isTrue, val)
      if (isTrue) {
        arr.splice(index, 1)
      } else {
        arr.push(val)
      }
      console.log(arr)
      this.scheduleForm.days = arr.join(',');
    },
    timeUnitSelectFun(index) {
      // this.timeUnitSelectShow[index] = this.timeUnitSelectShow[index] ? false : true;
      this.$set(this.timeUnitSelectShow, index, this.timeUnitSelectShow[index] ? false : true)
    },
    timeUnitItemClick(data, index) {
      this.timeUnitName[index] = data.name;
      if (index == 0) {
        this.scheduleForm.sunriseTimeUnit = data.id;
      }
      if (index == 1) {
        this.scheduleForm.sunsetTimeUnit = data.id;
      }
      // this.timeUnitSelectShow[index] = false;
      this.$set(this.timeUnitSelectShow, index, false)
    },
    sceneSelectFun() {
      this.sceneSelectShow = this.sceneSelectShow ? false : true;
    },
    sceneItemClick(data) {
      // this.sceneName = data.name;
      // this.scheduleForm.sceneId = data.id;
      // this.sceneSelectShow = false;
      console.log(data)
      let id = data.id;
      let sceneName = this.sceneName;
      let sceneId = this.sceneId;
      if(sceneId.indexOf(id)==-1){
        if(sceneName == ''){
          sceneName = data.name;
          sceneId = id;
        }else{
          sceneName = sceneName+','+data.name;
          sceneId = sceneId+','+id;
        }
      }else{
        let name = ''
        if(sceneId.indexOf(id)==0){
          id = id + ','
          name = data.name + ','
        }else{
          id = ',' + id
          name = ',' + data.name
        }
        sceneId = sceneId.replace(id,'')
        sceneName = sceneName.replace(name,'')
        // groupIds = groupIds.slice(obj.groupIds.indexOf(idss),idss.length);
      }
      console.log(sceneId,sceneName)

      this.$set(this,'sceneId',sceneId+'')
      this.$set(this,'sceneName',sceneName)
    },
    timeTypeSelectFun() {
      this.timeTypeSelectShow = this.timeTypeSelectShow ? false : true;
    },
    timeTypeItemClick(data) {
      this.timeTypeName = data.name;
      this.scheduleForm.timeType = data.id;
      this.timeTypeSelectShow = false;
    },
    // linkToFun(val,data){
    // }
    sceneNavGet() {
      base.ajax_post(
        allUrl.scene.scene_nav,
        {
          username: this.username,
          version: this.version,
          token: this.token,
          projectId:this.projectId,
        },
        {},
        data => {
          this.sceneNavList = data.data;
        },
        this
      )
    },
  },
  watch: {
    projectId: function () {
      this.sceneNavGet();
    }
    // updateRemRatio:function(){
    // }
  }
}
</script>

<style type="text/css" lang="less">
.schedule_main {
  position: absolute;
  top: 5.78rem;
  left: 0;
  width: 100%;
  height: calc(100% - 5.78rem);
  min-height: 50rem;
  margin: 0 auto;
  overflow: hidden;
  // position: relative;
  // display: flex;
  background: rgba(255, 255, 255, 0.85);

  
  .cont_box {
    position: relative;
    height: calc(100% - 2rem);
    padding: 5.35rem 0rem 0 27rem;
    .sceneSelect{
      position: absolute;
      top: 2rem;;left: 2rem;
      .select_lm{
        width: 20rem;
      }
      .select_lm{
        width: 20rem;
        .val_box {
          height: 3rem;
          .val {
            line-height: 3rem;
          }
          .icon_x {
            top: 0.8rem;
          }
        }
      }
    }
    .p1 {
      font-size: 1.8rem;
      font-family: Calibri;
      font-weight: normal;
      color: rgba(58, 99, 111, 1);
      margin-bottom: 1.84rem;

      .i {
        margin-right: 0.5rem;
        color: #ff0101;
      }
    }

    .form_box {
      .select_lm{
        width: 20rem;
        .val_box {
          height: 3rem;
          .val {
            line-height: 3rem;
          }
          .icon_x {
            top: 0.8rem;
          }
        }
      }

      .form_ul {
        margin-top: 4rem;

        // display: flex;
        // flex-wrap: wrap; //换行
        // align-content: flex-start; //display flex 布局换行后行间距清空。
        .flex_box {
          display: flex;
        }

        .li {
          // width: 50%;
          margin-right: 5rem;

          .select_lm .val_box {
            height: 2.5rem;
            line-height: 2.5rem;
          }

          .flex_box {
            display: flex;
            align-items: center;
          }

          &.margin_b {
            margin-bottom: 4.5rem;
          }
        }
      }

      .input1 {
        // margin: 3.6rem 0 10.35rem;
        width: 17.02rem;
        margin-left: 1.75rem;
        width: 17.02rem;

        &.el-input-number {
          line-height: initial;
        }

        &.number {
          width: 7.3rem;
        }

        // width: 32.54rem;
        // height: 3.33rem;
        // border: 0.09rem solid #3A636F;
        // border-radius: 0.44rem;
        // margin: 2.02rem 0 0 3.77rem;
        .el-input__inner {
          padding-left: 1.58rem;
          width: 100%;
          height: 2.5rem;
          line-height: 2.5rem;
          border: 0.09rem solid #3a636f;
          border-radius: 0.44rem;
          background-color: rgba(0, 0, 0, 0);

          font-size: 1.8rem;
          font-family: Calibri;
          font-weight: normal;
          color: #3a636f;
        }

        .el-input__prefix {
          width: 1.8rem;
          height: 1.8rem;
          top: 0.96rem;
          left: 0.79rem;

          .icon {
            width: 100%;
          }
        }

        .el-input__suffix {
          height: 2.5rem;
          line-height: 2.5rem;
          right: 1.49rem;
        }

        .span {
          margin-top: -0.2rem;
          font-size: 1.8rem;
          font-family: Calibri;
          font-weight: normal;
          color: #3a636f;
          position: relative;
          top: -0.2rem;
        }

        .el-input .el-select__caret {
          font-size: 1.8rem;
          color: rgba(58, 99, 111, 1);
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }

      .picker {
        width: 17.02rem;
        margin-left: 1.75rem;

        .el-input__inner {
          padding-left: 3.5rem;
          width: 17.02rem;
          height: 2.5rem;
          line-height: 2.5rem;
          border: 0.09rem solid #3a636f;
          border-radius: 0.44rem;
          background-color: rgba(0, 0, 0, 0);

          font-size: 1.8rem;
          font-family: Calibri;
          font-weight: normal;
          color: #3a636f;
        }

        .el-input__icon {
          line-height: 2.5rem;
        }

        .el-icon-time,
        .el-icon-date {
          &:before {
            color: rgba(58, 99, 111, 1);
            font-size: 1.8rem;
          }
        }

        .el-icon-circle-close {
          &:before {
            color: rgba(58, 99, 111, 0.8);
            font-size: 1.8rem;
          }
        }

        // .el-input__suffix{

        // }

      }
    }

    .flex_box {
      display: flex;

      // margin-bottom: 3rem;
      .flex_li {
        margin-right: 2.11rem;
        width: 4.5rem;
        height: 4.5rem;
        line-height: 4.5rem;
        text-align: center;
        background: #f4fbfd;
        border-radius: 50%;
        cursor: pointer;

        font-size: 1.8rem;
        font-family: Calibri;
        font-weight: normal;
        color: #3a636f;

        &.select {
          background: #2f9fff;
          color: #fff;
        }
      }
    }

    .add_btn {
      // width: 15.88rem;
      // height: 4.04rem;line-height: 4.04rem;
      // border: 0.09rem solid #3A636F;
      margin-top: 3rem;
      border-radius: 0.44rem;
      display: flex;
      align-items: center;

      .icon {
        // margin: 0 1.49rem 0 1.05rem;
        width: 4.28rem;
        height: 4.28rem;
        background-image: url(../img/icon/btn_bg1.png);
        background-position: center;
        background-size: 100% 100%;
      }
    }
  }

  .btn_box {
    position: absolute;
    // left: 7.37rem;
    bottom: 3.86rem;
    right: 7.19rem;
    display: flex;
    align-items: center;
    justify-content: flex-end;

    .btn1 {
      user-select: none;
      width: 9.91rem;
      height: 4.18rem;
      line-height: 4.18rem;
      background: #f4fbfd;
      border: 0.09rem solid #3a636f;
      border-radius: 0.26rem;
      text-align: center;

      font-size: 1.8rem;
      font-family: Calibri;
      font-weight: normal;
      color: #3a636f;
      cursor: pointer;
    }

    .btn2 {
      user-select: none;
      margin-left: 4.6rem;
      width: 9.91rem;
      height: 4.18rem;
      line-height: 4.18rem;
      background: #00c6ff;
      border: 0.09rem solid #00c6ff;
      border-radius: 0.26rem;
      text-align: center;

      font-size: 1.8rem;
      font-family: Calibri;
      font-weight: normal;
      color: #ffffff;
      cursor: pointer;
    }
  }
  .project_completed{
    position: fixed;
    top: 0;right: 0;left: 0;bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    
    .bg{
      position: absolute;
      width: 100%;
      height: 100%;
      background: rgba(0,0,0,0);
      z-index: -1;
      opacity: 0.5;
    }
    .form_box{
      position: relative;
      width: 36.51rem;
      height: 18.09rem;
      padding-top: 2.83rem;
      background: #FFFFFF;
      border: 0px solid #3A636F;
      border-radius: 0.2rem;
      opacity: 0.9;
      .span{
        font-family: Calibri;
        color: #3A636F;
        text-align: center;
        width: 23.22rem;
        font-weight: 400;
        font-size: 1.8rem;
        color: #4C717C;
        margin: auto;
      }
      .btn_box0{
        // position: absolute;
        // bottom: 0rem;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 5.07rem;
        // margin: 4.47rem auto 0;
        // width: 26.69rem;
        
        .btn2{
          width: 6.25rem;
          height: 2.63rem;
          background: #00C6FF;
          border-radius: 0.2rem;

          line-height: 2.63rem;
          border: 0.09rem solid #00C6FF;
          text-align: center;
          // font-family: Calibri;
          // font-weight: normal;
          // color: #FFFFFF;
          cursor: pointer;
          user-select: none;

          font-family: Calibri;
          font-weight: 400;
          font-size: 1.8rem;
          color: #FFFFFF;
        }
      }
    }
  }
}
// .schedule_main.themeType_1 {
//   background: rgba(250,  237, 218, 0.85);
//   .cont_box {
//     .p1 {
//       color: #682411;
//       .i {
//         margin-right: 0.5rem;
//         color: #ff0101;
//       }
//     }
//     .form_box {
//       .input1 {
//         .el-input__inner {
//           border: 0.09rem solid #682411;
//           background-color: rgba(0, 0, 0, 0);
//           color: #682411;
//         }
//         .span {
//           color: #682411;
//         }
//         .el-input .el-select__caret {
//           color: #682411;
//         }
//       }
//       .picker {
//         .el-input__inner {
//           border: 0.09rem solid #682411;
//           background-color: rgba(0, 0, 0, 0);
//           color: #682411;
//         }
//         .el-icon-time,
//         .el-icon-date {
//           &:before {
//             color: #682411;
//           }
//         }

//         .el-icon-circle-close {
//           &:before {
//             color: #682411;
//           }
//         }
//       }
//     }
//     .flex_box {
//       .flex_li {
//         background: #faedda;
//         color: #682411;
//         &.select {
//           background: #fdbe6e;
//           color: #fff;
//         }
//       }
//     }
//     .add_btn {
//       .icon {
//         background-image: url(../img/orange/btn_bg1.png);
//       }
//     }
//   }

//   .btn_box {
//     .btn1 {
//       background: #f2cd9b;
//       border: 0.1rem solid #682411;
//       color: #682411;
//     }
//     .btn2 {
//       background: #f44336;
//       border: 0.09rem solid #f44336;
//       color: #ffffff;
//     }
//   }
//   .project_completed{
//     .form_box{
//       background: #FFFFFF;
//       border: 0px solid #3A636F;
//       opacity: 0.9;
//       .span{
//         color: #682411;
//       }
//       .btn_box{
//         .btn2{
//           background: #f44336;
//           border: 0.09rem solid #f44336;
//           color: #ffffff;
//         }
//       }
//     }
//   }
//   .select_lm .select_xl_lm {
//     .icon,.ul {
//       background: #faedda;
//     }
//   }
//   .select_lm .val_box .icon_x {
//     width: 0.8rem;
//     height: 1.3rem;
//     top: 0.6rem;
//     background-image: url("../img/orange/rightArrow.png");
//   }
//   .scrollbar_style::-webkit-scrollbar-thumb {/*滚动条里面小方块*/
//       border-radius: 0.5rem;
//       // background: #DAE6E0;
//       background: #682411;
//   }
//   .scrollbar_style::-webkit-scrollbar-track {/*滚动条里面轨道*/
//       background: #faedda;
//   }
// }
</style>